import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import ReactPlayer from 'react-player';

import style from './index.module.scss';

const VideoPlayer = ({ url, rotate = false, controls = false }) => {
  const videoRef = useRef();
  const [currentTime, setCurrentTime] = useState();
  const [isError, setIsError] = useState(false);

  const onError = () => {
    setCurrentTime(videoRef.current.getCurrentTime());
    setIsError(true);
  };

  const onReady = () => {
    if (isError) {
      videoRef.current.seekTo(currentTime);
      setIsError(false);
    }
  };

  return (
    <div
      className={classNames(style.component, {
        [style.rotate]: rotate,
      })}
      data-testid="video-container"
    >
      <ReactPlayer
        ref={videoRef}
        className="player"
        url={url}
        controls={controls}
        width={rotate ? '150%' : '100%'}
        height={rotate ? '150%' : '100%'}
        style={{
          transform: rotate ? 'translate(-17%, -17%)' : 'inherit',
        }}
        onError={onError}
        onReady={onReady}
      />
    </div>
  );
};

VideoPlayer.propTypes = {
  url: PropTypes.string.isRequired,
  rotate: PropTypes.bool,
  controls: PropTypes.bool,
};

export default VideoPlayer;
